module.exports = __webpack_public_path__ + "img/20190529161859425.4a0c023a.png";